/**
 * Breakpoint sizes used for screen media queries.
 *
 * @see https://corgi-x.tfd.engineering/system/responsive-design
 */
export enum Breakpoint {
  /** Extra small breakpoint (all screens). */
  XS = 0,
  /** Small breakpoint (e.g. iPhone SE). */
  SM = 375,
  /** Medium breakpoint (e.g. AirPad Mini, small tablets). */
  MD = 710,
  /** Large breakpoint (e.g. landscape modes, tablets). */
  LG = 1024,
  /** Extra-large breakpoint (e.g. desktop and wide screens). */
  XL = 1400,
}

/**
 * The name of the breakpoints to match different viewports.
 *
 * @see https://corgi-x.tfd.engineering/system/responsive-design
 */
export type BreakpointSize = Lowercase<keyof typeof Breakpoint>;
